import React from "react";
import PropTypes from "prop-types";
import { Wrapper } from "../Wrapper";
import { PlayPauseButton } from "./PlayPauseButton";
import { RangeSlider } from "./RangeSlider";
import { ReplayButton } from "./ReplayButton";
import { SkipButton } from "./SkipButton";
import { Timer } from "./Timer";

import style from "./style.module.scss";

/**
 * TimerBar:
 * This component contains the main controls of timer player (play, pause, skip, replay, slider)
 *
 */

export function TimerBar(props) {
  const onChangeFrame = (frame) => {
    props.onClickPause();
    props.onChangeFrame(frame);
  };

  const onClickReplay = () => {
    props.onChangeFrame(props.min);
    props.onClickPlay();
  };

  const onClickSkip = () => {
    props.onChangeFrame(props.max);
    props.onComplete();
  };

  return (
    <Wrapper className={style.timerBar}>
      <PlayPauseButton
        className={style.timerBar_playPause}
        isPaused={props.isPaused}
        onClickPause={props.onClickPause}
        onClickPlay={props.onClickPlay}
        disabled={props.disabled}
        tabIndex={props.tabIndex}
      />
      <RangeSlider
        className={style.timerBar_rangeSlider}
        currentFrame={props.currentFrame}
        onChangeFrame={onChangeFrame}
        min={props.min}
        max={props.max}
        disabled={props.disabled}
        tabIndex={props.tabIndex}
      />
      <ReplayButton
        className={style.timerBar_replayButton}
        onClick={onClickReplay}
        disabled={props.disabled}
        tabIndex={props.tabIndex}
      />
      <Wrapper className={style.timerBar_skipBlock}>
        <SkipButton
          onClick={onClickSkip}
          disabled={props.disabled}
          tabIndex={props.tabIndex}
        />
        <Timer
          value={props.displayTime}
          min={props.min}
          max={props.max}
          currentFrame={props.currentFrame}
        />
      </Wrapper>
    </Wrapper>
  );
}

TimerBar.propTypes = {
  /**
   * callback function to invoke on video playback is complete
   */
  onComplete: PropTypes.func,

  ...PlayPauseButton.propTypes,
  ...RangeSlider.propTypes,
  ...ReplayButton.propTypes,
  ...SkipButton.propTypes,
};
